<template>
  <div id="SavedSchools" >
    <!-- Mobile Layout -->
    <v-card  tile class=" mt-2  mb-3 hidden-md-and-up "  id="tileCard" @click="moreInfo(savedSchool.school_name)">
      <v-list class="pt-0 mt-0 " two-line >
        <v-list-item >
          <v-list-item-avatar class="">
            <img :src="savedSchool.program_image" alt="">
          </v-list-item-avatar>
          <v-list-item-content class=" mt-1">

              <v-list-item-title>{{ savedSchool.school_name }}</v-list-item-title>
              <!-- <v-list-tile-sub-title ><v-icon small>event</v-icon> <span class="">{{savedSchool.application_deadline | moment(" MMMM Do, YYYY")}}</span></v-list-tile-sub-title> -->
          <v-list-item-subtitle >{{ savedSchool.program_state }}</v-list-item-subtitle >
          <v-progress-linear
          :color="changeColor "
          height="15"
          :value="progressStats.passed / progressStats.total * 100 "
          rounded
          bottom
          reactive
          class="mt-1"
          >
          <span class="white--text font-weight-bold">{{Math.ceil(progressStats.passed / progressStats.total * 100)}}% completed</span>
        </v-progress-linear>
        <p class="text--primary mb-0 mt-1">Status: {{ APPLICATION_STATUS[currentStatus] }}</p>

                  <school-application-status  :school="savedSchool" />


          </v-list-item-content>


          <v-list-item-action class="mb-0">

            <v-btn  icon rounded :ripple="false" >
              <v-icon color="grey">mdi-chevron-right</v-icon>
            </v-btn>



          </v-list-item-action>


        </v-list-item>



      </v-list>
    </v-card>

    <!-- Desktop Layout -->
    <v-card
      class=" mt-3 hidden-sm-and-down "
      hover
      @click="moreInfo(savedSchool.school_name)"

      >
      <v-card-title class="d-block text-truncate">
        <v-avatar>
          <img :src="savedSchool.program_image" >
        </v-avatar>
        {{ savedSchool.school_name }}

      </v-card-title>

      <v-card-text class="pt-1 pb-2">
        <v-progress-linear
          :color="changeColor"
          height="15"
          :value="progressStats.passed / progressStats.total * 100 "
          rounded
          bottom
          reactive
          class="mt-1"
          >
          <span class="white--text font-weight-bold">{{Math.ceil(progressStats.passed / progressStats.total * 100)}}% completed</span>
        </v-progress-linear>
        <p class="text--primary mb-0 mt-1">Status: {{ APPLICATION_STATUS[currentStatus] }}</p>
        <span class="text--primary">State: <span>{{savedSchool.program_state}}</span></span> <br>
          <span class="text--primary">
          <span>Application Deadline: <span v-if="savedSchool.application_deadline !== '' && savedSchool.caspa_participant" class="subheading  mb-0  ">{{savedSchool.application_deadline | removeTimeFromDate | moment(" MM/DD/YYYY")}}</span></span><br>

        </span>
        <v-card-actions class="pl-0 pt-0">
          <school-application-status  :school="savedSchool" />
        </v-card-actions>


      </v-card-text>

    </v-card>




  </div>
</template>

<script>

const IN_PROGRESS = 'IN_PROGRESS'
const IS_COMPLETE = 'IS_COMPLETE'
const APPLIED = 'APPLIED'
const INTERVIEW = 'INTERVIEW'
const REJECTED = 'REJECTED'
const ACCEPTED = 'ACCEPTED'
const HOLD = 'HOLD'

const STATUSES = [
  IN_PROGRESS,
  IS_COMPLETE,
  APPLIED,
  INTERVIEW,
  ACCEPTED,
  HOLD,
  REJECTED,
]

const APPLICATION_STATUS = {
  IN_PROGRESS: 'In Progress',
  IS_COMPLETE: 'Ready to Apply',
  APPLIED: 'Applied',
  INTERVIEW: 'Called for Interview',
  ACCEPTED: 'Accepted',
  HOLD: 'Wait Listed',
  REJECTED: 'Rejected',

}
  import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
  import userMixins from '@/mixins/usersmixin'
  import checkDegreeMixin from '@/mixins/requirementchecks/checkdegreemixin'
  import checkGPAMixin from '@/mixins/requirementchecks/checkgpamixin'
  import checkPrerequisitesMixin from '@/mixins/requirementchecks/checkprerequisitesmixin'
  import checkHealthcareExperienceMixin from '@/mixins/requirementchecks/checkhealthcareexperiencemixin'
  import checkPaShadowingMixin from '@/mixins/requirementchecks/checkpashadowingmixin'
  import checkEvaluationMixin from '@/mixins/requirementchecks/checkevaluationmixin'
  import checkGreMixin from '@/mixins/requirementchecks/checkgremixin'
  import checkCasperMixin from '@/mixins/requirementchecks/checkcaspermixin'
  import checkpacatMixin from '@/mixins/requirementchecks/checkpacatmixin'
  import checkInternationalExamsMixin from '@/mixins/requirementchecks/checkinternationalexamsmixin'
  import overallCheckMixin from '@/mixins/requirementchecks/overallmixin'
  import SchoolApplicationStatus from './SchoolApplicationStatus'
export default {
  mixins: [userMixins,overallCheckMixin,checkDegreeMixin, checkGPAMixin, checkPrerequisitesMixin, checkHealthcareExperienceMixin, checkPaShadowingMixin, checkEvaluationMixin, checkGreMixin, checkCasperMixin, checkInternationalExamsMixin, checkpacatMixin ],
  props:['savedSchool', 'visibleSchools'],
  components: {
    SchoolApplicationStatus
  },
  data() {
    return {
      activeFilter: IN_PROGRESS,
      APPLICATION_STATUS,
      APPLICATION_STATUSES: STATUSES,
      APPLICATION_STATUSES_MAP: APPLICATION_STATUS,
      busy: false
    };
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    moreInfo () {
        this.$router.push('/dashboard/savedschools/savedschoolinfo/' + this.savedSchool.school_name.split(' ').join('-'))
    },
    schoolStatus (data) {
      return this.savedSchools.filter((s) => {
        const hasStatus = this.userSchoolApplications.find((sch) => sch.id === s.id)
        if (!hasStatus) {
          return data === IN_PROGRESS
        }
        return hasStatus.status === data
      })
    }
  },
  computed: {
        changeColor () {
        if(this.progressStats.passed / this.progressStats.total * 100 === 100) {
          return 'green'
        }
        else {
          return 'red'
        }
      },
     userSchoolApplications () {
      return this.$store.getters.userSchoolApplications
    },
    savedSchools() {
      return this.$store.getters.savedSchools;
    },
      currentStatus () {
      if (!this.user.school_applications) return IN_PROGRESS
      if (!this.user.school_applications[this.savedSchool.id]) return IN_PROGRESS
      return this.user.school_applications[this.savedSchool.id].status ? this.user.school_applications[this.savedSchool.id].status : IN_PROGRESS
    }
  }
};
</script>

<style scoped>
hr {
  position:absolute;
  width:80%;
  margin-top: 40px;

  opacity: .2;
}
.signupOrLoginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size: 20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}

.card {
  border-radius: 3px;
}

#tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/SavedSchool.vue